import { type Option, Select } from '@avanta/shared/components/ui/Select';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { Building, MapPin } from 'lucide-react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AppointmentsReservePayload } from '../../../types';
import { StepSection } from '../StepSection';

interface CenterSectionProps {
  citiesOptions: Option[];
  centersOptions: Option[];
  city: string | undefined;
  backofficeCenterId: string | undefined;
  onCityChange: (value: string) => void;
}

export const CenterSection = ({
  citiesOptions,
  centersOptions,
  city,
  backofficeCenterId,
  onCityChange,
}: CenterSectionProps): React.ReactElement => {
  const { setValue } = useFormContext();
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  return (
    <StepSection
      title={t('AppointmentsReserve.Steps.center.title')}
      className="grid am-lg:grid-cols-2 gap-4 w-full"
      containerClassName="gap-4"
    >
      <Select
        options={citiesOptions}
        placeholder={t('AppointmentsReserve.Steps.city.placeholder')}
        label={t('AppointmentsReserve.Steps.city.label')}
        className="w-full"
        onValueChange={onCityChange}
        value={city}
        leftIcon={MapPin}
      />
      <Select
        options={centersOptions}
        placeholder={t('AppointmentsReserve.Steps.center.placeholder')}
        label={t('AppointmentsReserve.Steps.center.label')}
        className="w-full"
        value={backofficeCenterId}
        disabled={!city}
        onValueChange={value => setValue(AppointmentsReservePayload.backofficeCenterId, value)}
        leftIcon={Building}
      />
    </StepSection>
  );
};
